import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/1@2x.png'
import _imports_1 from '@/assets/images/3@2x.png'
import _imports_2 from '@/assets/images/2@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-7ec8e674"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "warning-select-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-dianpu1" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-arrow-down-filling" }, null, -1))
const _hoisted_5 = { class: "monitor" }
const _hoisted_6 = { class: "monitor-til" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "基础指标实时监控", -1))
const _hoisted_8 = { class: "monitor-list" }
const _hoisted_9 = { class: "warning" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" AI预警-整改项")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 昨日 ")
const _hoisted_12 = { class: "warning" }
const _hoisted_13 = { class: "warning" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" AI预警-非整改项")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 昨日 ")
const _hoisted_16 = { class: "warning" }
const _hoisted_17 = { class: "notice" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-tile" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-jingbao" }),
  /*#__PURE__*/_createElementVNode("span", null, "预警通知")
], -1))
const _hoisted_19 = { class: "notice-list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "home-top-til" }, "智能分析", -1))
const _hoisted_21 = { class: "home-top margin21" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }, null, -1))
const _hoisted_25 = { class: "recommend" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dl", null, [
  /*#__PURE__*/_createElementVNode("dt", null, "产品推荐"),
  /*#__PURE__*/_createElementVNode("dd", null, "识别顾客并通知门迎服务")
], -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("点击了解")
const _hoisted_28 = {
  key: 0,
  class: "analyse"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "analyse-head" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "上座率分析")
], -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "analyse-dates-text" }, "近7日数据", -1))
const _hoisted_31 = { class: "progress-list" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "progress-box" }
const _hoisted_34 = { class: "aiWarningGenerateTask" }
const _hoisted_35 = { class: "task-head" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("text", { class: "task-title" }, "AI预警生成任务", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("查看全部")
const _hoisted_38 = { class: "task-list" }
const _hoisted_39 = { class: "task-list-item" }
const _hoisted_40 = { class: "task-list-font" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" 创建任务 ")
const _hoisted_42 = { class: "task-list-item" }
const _hoisted_43 = { class: "task-list-font" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 待修改 ")
const _hoisted_45 = { class: "task-list-item" }
const _hoisted_46 = { class: "task-list-font" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" 已完成 ")

import { ref, onUnmounted, onActivated, onMounted, reactive } from 'vue'
import { Toast, Dialog } from 'vant'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import {
  getAttendance,
  getHomeData,
  getShops,
  getRecordData,
  getBusinessDataAll
} from '@/api/shop'
import ComHeader from '../../components/ComHeader/index.vue'
import { IShop, IBusiness } from '@/utils/interface'
import {
  copyToClipboard,
  getDateTimeStamp,
  getDateDiff,
  formatTime,
  getValueBykey,
  comDialog,
  isCheckTimeout
} from '@/utils'
import router from '@/router'
// import comHeader from '@/components/header/index.vue'

// onUnmounted(() => {
//   clearInterval(time.value)
// })


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

// onMounted(() => {
//   store.commit('user/setToken', '')
// })
onActivated(() => {
  init()
})

const init = () => {
  const platformType = route.query.client_id ? 'daHua' : 'hik'
  ;(document.querySelector('html') as HTMLElement).className = platformType
  store.commit('user/setPlatformType', platformType)
  // if (store.getters.token && !isCheckTimeout()) {
  //   getData()
  if (
    process.env.NODE_ENV === 'development' ||
    (store.getters.token && route.meta.isBack)
  ) {
    getData()
  } else {
    const params = {
      platformType,
      ticket: route.query.ticket
    }
    if (route.query.client_id) {
      // eslint-disable-next-line dot-notation
      params['clientId'] = route.query.client_id
    }
    store.dispatch('user/login', params).then((res) => {
      console.log('login_res', res)

      if (res.token) {
        getData()
      } else {
        Dialog.alert({
          title: '警告',
          message: '登录失败',
          theme: 'round-button'
        }).then(() => {
          // on close
        })
      }
    })
  }
}

const route = useRoute()
const data = ref<any>(null)
const showPicker = ref(false)
const columns = ref<IShop[]>([])
const taskObj = reactive({
  all: 0,
  wait: 0,
  complete: 0
})

const goTo = (shopNo: string) => {
  router.push(`/analysis/mealRate?shopNo=${shopNo}&timeType=1`)
}

const tableRateList = ref<IBusiness[]>([])
const getData = () => {
  const arr = [
    getHomeData({
      storeNo: store.getters.storeNo
    }),
    getShops(),
    getRecordData()
    // store.dispatch('user/getUserInfo')
  ]
  if (store.getters.isHdl) {
    arr.push(
      getBusinessDataAll({
        companyId: '1',
        timeType: 1,
        pageSize: 300,
        page: 1
      })
    )
  }

  interface taskItem {
    qty: number
    rectifyStatus: string
  }

  Promise.all(arr).then((res: any) => {
    data.value = res[0]
    columns.value = res[1] && res[1].storeList
    if (store.getters.isHdl && res[3]) {
      tableRateList.value = res[3]
    }
    if (res[2]?.length) {
      taskObj.wait = 0
      taskObj.complete = 0
      taskObj.all = 0
      res[2].map((item: taskItem) => {
        if (item.rectifyStatus === '1' || item.rectifyStatus === '2') {
          taskObj.wait += item.qty
        } else if (item.rectifyStatus === '3' || item.rectifyStatus === '4') {
          taskObj.complete += item.qty
        }
      })
      taskObj.all = taskObj.wait + taskObj.complete
    }
  })
}

const onConfirm = (value: IShop) => {
  store.commit('store/setStoreNo', value.storeNo)
  showPicker.value = false
  getData()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_skeleton = _resolveComponent("van-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ComHeader, {
      height: 16,
      title: "门店应用型算法平台"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_router_link, {
          tag: "i",
          to: "/shop",
          class: "iconfont icon-dianpu"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "warning-select",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (showPicker.value = true))
      }, [
        _hoisted_3,
        _createElementVNode("div", {
          class: "warning-select-value",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showPicker.value = true))
        }, _toDisplayString(_unref(store).getters.storeNo && columns.value.length
              ? _unref(getValueBykey)(
                  'storeNo',
                  _unref(store).getters.storeNo,
                  columns.value,
                  'storeName'
                )
              : '全部门店'), 1),
        _hoisted_4
      ]),
      _createVNode(_component_van_popup, {
        show: showPicker.value,
        "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((showPicker).value = $event)),
        round: "",
        position: "bottom"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_picker, {
            columns: columns.value,
            "columns-field-names": { text: 'storeName' },
            onCancel: _cache[2] || (_cache[2] = ($event: any) => (showPicker.value = false)),
            onConfirm: onConfirm
          }, null, 8, ["columns"])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", null, "更新于：" + _toDisplayString(_unref(getDateDiff)(_unref(getDateTimeStamp)(_unref(formatTime)(+new Date())))), 1)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_van_skeleton, {
          row: 3,
          avatar: "",
          loading: !(data.value && data.value.productCount != null)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/warning?type=1" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_9, _toDisplayString(data.value && data.value.productCount), 1),
                _createElementVNode("p", null, [
                  _hoisted_10,
                  _createElementVNode("i", {
                    class: "iconfont icon-wenhao",
                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (
                  _unref(comDialog)(
                    '橙色数字是指所有门店所有产生预警数，昨日增加是指昨日整天产生预警数'
                  )
                ), ["prevent"]))
                  })
                ]),
                _createElementVNode("span", null, [
                  _hoisted_11,
                  _createElementVNode("b", _hoisted_12, _toDisplayString(data.value && data.value.productPassCount > -1 ? '+' : '-') + _toDisplayString(data.value && data.value.productPassCount), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_van_skeleton, {
          row: 3,
          loading: !(data.value && data.value.moneyCount != null)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/warning?type=2" }, {
              default: _withCtx(() => [
                _createElementVNode("h3", _hoisted_13, _toDisplayString(data.value && data.value.moneyCount), 1),
                _createElementVNode("p", null, [
                  _hoisted_14,
                  _createElementVNode("i", {
                    class: "iconfont icon-wenhao",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
                  _unref(comDialog)(
                    '橙色数字是指所有门店所有产生预警数，昨日增加是指昨日整天产生预警数'
                  )
                ), ["prevent"]))
                  })
                ]),
                _createElementVNode("span", null, [
                  _hoisted_15,
                  _createElementVNode("b", _hoisted_16, _toDisplayString(data.value && data.value.moneyPassCount > -1 ? '+' : '-') + _toDisplayString(data.value && data.value.moneyPassCount), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value && data.value.messageList, (item, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: index,
            to: "/message"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(item.messageInfo), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(getDateDiff)(_unref(getDateTimeStamp)(item.time))), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _hoisted_20,
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_router_link, { to: "/board?type=1" }, {
        default: _withCtx(() => [
          _hoisted_22
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/board?type=2" }, {
        default: _withCtx(() => [
          _hoisted_23
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/analysis" }, {
        default: _withCtx(() => [
          _hoisted_24
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createVNode(_component_router_link, {
        to: "/product",
        class: "btn"
      }, {
        default: _withCtx(() => [
          _hoisted_27
        ]),
        _: 1
      })
    ]),
    (_unref(store).getters.isHdl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
          _hoisted_29,
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableRateList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "progress-item",
                key: index,
                onClick: ($event: any) => (goTo(item.shopNo))
              }, [
                _createElementVNode("span", null, _toDisplayString(_unref(store).getters.storeNo ? item.time.substr(5, 5) : item.shopName), 1),
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", {
                    class: "progress-main",
                    style: _normalizeStyle({ width: item.mealRate })
                  }, null, 4)
                ]),
                _createElementVNode("span", null, _toDisplayString(item.mealRate), 1)
              ], 8, _hoisted_32))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _hoisted_36,
        _createVNode(_component_router_link, { to: "/task/list" }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("text", _hoisted_40, _toDisplayString(_unref(taskObj).all), 1),
          _hoisted_41
        ]),
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("text", _hoisted_43, _toDisplayString(_unref(taskObj).wait), 1),
          _hoisted_44
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("text", _hoisted_46, _toDisplayString(_unref(taskObj).complete), 1),
          _hoisted_47
        ])
      ])
    ])
  ]))
}
}

})